import Button from 'components/_parts/atoms/button';
import Input from 'components/_parts/atoms/input';
import Label from 'components/_parts/atoms/label';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import { HIT_WLA_OC_CREATE, HIT_WLA_OC_UPDATE } from 'redux/actions/wla';
import styled from 'styled-components';
import './index.scss';
import TooglCustom from 'components/_parts/atoms/toogle';
import initialValues from './initialValues';
import validationSchema from './validationSchema';
import CleanData from './cleanData';

const FullScreenOverlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  right: 0;
  right: 0;
  top: 0;
`;

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
`;

function WorkerType(props) {
  const dispatch = useDispatch();
  const isSub = props.typeForm.includes('sub');
  const { t } = props;

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema({ t }),
    onSubmit: async (values) => {
      try {
        if (props.typeForm.includes('edit')) {
          values.order === props.data?.order ? delete values.order : values.order; // order tidak ada perubahan = tidak dikirimkan / dihapus
          const newPayload = CleanData(values);
          dispatch({
            type: HIT_WLA_OC_UPDATE,
            payload: {
              data: newPayload,
              id: props.ids,
              type: props.category,
            },
          });
        } else {
          const payload = { ...values, type: isSub ? 'detail' : 'parent', parent_id: isSub ? props?.data?.wla_category_id : '' };
          const newPayload = CleanData(payload);
          dispatch({
            type: HIT_WLA_OC_CREATE,
            payload: {
              data: newPayload,
              type: props.category,
            },
          });
        }
        props.funcModal(false);
        formik.resetForm();
      } catch (error) {
        props.funcModal(false);
        formik.resetForm();
      }
    },
  });
  useEffect(() => {
    if (props.typeForm.includes('edit')) {
      formik.setValues({
        title: props.data?.title,
        order: props.data?.order,
        status: props.data?.status,
        wla_category_id: props.data?.wla_category_id,
      });
    }
  }, [props.typeForm]);

  useEffect(() => {
    if (props.showModal && !props.typeForm.includes('edit')) {
      formik.resetForm();
    }
  }, [props.showModal]);

  let checked_ = 0;
  if (formik.values.status !== undefined) {
    checked_ = formik.values.status === 'active' ? 0 : 1;
  }

  const labelWla = {
    create: t('company.add_category'),
    'create-sub': t('company.add_sub_category'),
    edit: t('company.edit_category'),
    'edit-sub': t('company.edit_sub_category'),
  };

  return (
    <>
      {props.modal
        && createPortal(
          <>
            <FullScreenOverlay className="cs_modal-bg" />
            <div
              id="wla_categoryModal"
              className={`${isSub ? 'positionSub' : 'positionMain'} cs_modal-container-activity-type d-flex justify-content-between flex-column`}
              ref={props.innerRef}
            >
              <Label
                className="text-center"
                typeLabel="label_modal"
                style={{
                  fontSize: '16px',
                }}
              >
                {labelWla[props.typeForm]}
              </Label>
              <div className="cs_modal-worktype">
                <div>
                  <Input
                    isError={
                      formik.touched.title && Boolean(formik.errors.title)
                    }
                    validateMessage={formik.errors.title}
                    type="text"
                    name="title"
                    onChange={formik.handleChange}
                    value={formik?.values?.title}
                    placeholder={t('company.category_name')}
                  />
                </div>
              </div>
              <div className="cs_modal-worktype">
                <div>
                  <Input
                    isError={
                      formik.touched.order && Boolean(formik.errors.order)
                    }
                    validateMessage={formik.errors.order}
                    type="number"
                    name="order"
                    onChange={formik.handleChange}
                    value={formik?.values?.order}
                    placeholder={t('company.order')}
                  />
                </div>
              </div>
              {props?.typeForm.includes('edit') && (
                <div className="d-flex justify-content-between px-3 mt-4">
                  <p style={{ fontSize: '12px', fontWeight: '500' }}>{t('job_desc.status')}</p>
                  <TooglCustom
                    id="button-visibility"
                    name="status"
                    checked={checked_}
                    leftStatus={t('org.job_lvl.form.active')}
                    rightStatus={t('org.job_lvl.form.inactive')}
                    onChange={() => {
                      formik.setValues({
                        ...formik.values,
                        status:
                          formik.values.status === 'active' ? 'inactive' : 'active',
                      });
                    }}
                  />
                </div>
              )}

              <div className="d-flex justify-content-end">
                <ButtonMod
                  func={(e) => {
                    formik.handleSubmit(e);
                    setTimeout(() => {
                      props.funcId(null);
                    }, 1000);
                  }}
                >
                  {t('board.save')}
                </ButtonMod>
              </div>
            </div>
          </>,
          document.getElementById('custom_wla_list'),
        )}
    </>
  );
}

export default WorkerType;
